/**
 * Type-safe accessor for CSS-module class maps.
 *
 * With `noUncheckedIndexedAccess` enabled, `styles['key']` is typed as
 * `string | undefined`, which antd components reject under
 * `exactOptionalPropertyTypes` (their `className?: string` has no `| undefined`).
 * This helper narrows the lookup back to `string`, falling back to an empty
 * string for missing keys.
 */
export type CssModule = Record<string, string>

export const cx = (styles: CssModule, key: string): string => styles[key] ?? ''
